import { AdminCrudPage, AdminCrudPageConfig } from '@/components/admin';

const config: AdminCrudPageConfig<{ id: string; [key: string]: unknown }> = {
  title: 'Account Types',
  apiEndpoint: '/ledger/account-types/',
  queryKey: 'accountTypes',
  columns: [
    { key: 'name', label: 'Name' },
    { key: 'code', label: 'Code' },
    { key: 'category', label: 'Category' },
  ],
  formFields: [
    { name: 'name', label: 'Name', type: 'text', required: true },
    { name: 'code', label: 'Code', type: 'text', required: true },
    { name: 'category', label: 'Category', type: 'select', options: [
      { value: 'asset', label: 'Asset' },
      { value: 'liability', label: 'Liability' },
      { value: 'equity', label: 'Equity' },
      { value: 'revenue', label: 'Revenue' },
      { value: 'expense', label: 'Expense' },
    ], required: true },
  ],
};

export function AccountTypesPage() {
  return <AdminCrudPage config={config} />;
}
